import { track } from "common/utils/mixpanel/tracker";

// Getters
const $$getSampleInfoTooltips = () => $(".js-sample-info-tooltip");
const getTooltipTriggerType = $$element => $$element.attr("data-trigger");
const getTooltipId = $$element => $$element.attr("aria-describedby");
const $getTooltipElement = tooltipId => document.getElementById(tooltipId);
const getTrackingSource = $$element => $$element.attr("data-tracking-source");
const getUniqueNamespace = $$element => {
  const elementIndex = $$getSampleInfoTooltips().index($$element);
  return `click.sample-info-tooltip-${elementIndex}`;
};

// Setters
const setTooltipInitialized = $$element => {
  $$element.data("sample-info-tooltip-init", true);
};
const setTooltipVisible = $$element => {
  $$element.tooltip("show");
};
const setTooltipHidden = $$element => {
  $$element.tooltip("hide");
};

// Tracking
const trackTooltipShown = ($$element, action) => {
  const source = getTrackingSource($$element);
  track("made_sample_info_tooltip_shown", { source, action });
};

// Actions
const shouldHideTooltipOnMouseLeave = $$element => {
  const tooltipId = getTooltipId($$element);
  const $tooltipElem = $getTooltipElement(tooltipId);
  return !$tooltipElem || !$tooltipElem.matches(":hover");
};

const shouldHideTooltipOnClick = ($$element, event) => {
  const tooltipId = getTooltipId($$element);
  const $tooltipElem = $getTooltipElement(tooltipId);

  const isClickOnTrigger = $$element.is(event.target) || $$element.has(event.target).length > 0;
  const isClickOnTooltip =
    $tooltipElem && ($tooltipElem === event.target || $tooltipElem.contains(event.target));

  return !isClickOnTrigger && !isClickOnTooltip;
};

const handleMouseEnter = $$element => () => {
  setTooltipVisible($$element);
};

const handleMouseLeave = $$element => () => {
  setTimeout(() => {
    if (shouldHideTooltipOnMouseLeave($$element)) {
      setTooltipHidden($$element);
    }
  }, 100);
};

const handleTooltipContentMouseLeave = $$element => () => {
  setTooltipHidden($$element);
};

const handleTooltipInserted = $$element => () => {
  const tooltipId = getTooltipId($$element);
  const $tooltipElem = $getTooltipElement(tooltipId);

  if (!$tooltipElem) return;

  $($tooltipElem).on("mouseleave", handleTooltipContentMouseLeave($$element));
};

const handleTriggerClick = $$element => event => {
  event.stopPropagation();
  const isShown = getTooltipId($$element);

  if (isShown) {
    setTooltipHidden($$element);
  } else {
    setTooltipVisible($$element);
  }
};

const handleDocumentClick = $$element => event => {
  if (shouldHideTooltipOnClick($$element, event)) {
    setTooltipHidden($$element);
  }
};

const handleTooltipShown = $$element => () => {
  trackTooltipShown($$element, "click");
  const namespace = getUniqueNamespace($$element);
  setTimeout(() => {
    $(document).on(namespace, handleDocumentClick($$element));
  }, 0);
};

const handleTooltipHidden = $$element => () => {
  const namespace = getUniqueNamespace($$element);
  $(document).off(namespace);
};

const initTooltipHoverBehavior = $$element => {
  $$element.on("mouseenter", handleMouseEnter($$element));
  $$element.on("mouseleave", handleMouseLeave($$element));
  $$element.on("inserted.bs.tooltip", handleTooltipInserted($$element));
  $$element.on("shown.bs.tooltip", () => trackTooltipShown($$element, "hover"));
};

const initTooltipClickBehavior = $$element => {
  $$element.on("click", handleTriggerClick($$element));
  $$element.on("shown.bs.tooltip", handleTooltipShown($$element));
  $$element.on("hidden.bs.tooltip", handleTooltipHidden($$element));
};

const initSingleTooltip = $$element => {
  if ($$element.data("sample-info-tooltip-init")) return;

  setTooltipInitialized($$element);

  $$element.tooltip({
    delay: { hide: 0 },
    trigger: "manual"
  });

  const triggerType = getTooltipTriggerType($$element);

  if (triggerType === "hover") {
    initTooltipHoverBehavior($$element);
  } else if (triggerType === "click") {
    initTooltipClickBehavior($$element);
  }
};

// Inits
const initSampleInfoTooltips = () => {
  $$getSampleInfoTooltips().each(function () {
    initSingleTooltip($(this));
  });
};

export default initSampleInfoTooltips;
